"use client";

import React from "react";
import { Zap, Bike, BookOpenCheck, HandHeart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefitsData = [{
  title: "Обучение через движение",
  description: "Нейроразвивающая терапия для восстановления контроля над движениями и существенного улучшения качества жизни ребенка.",
  icon: <Zap className="w-14 h-14 text-primary" strokeWidth={1.5} />
}, {
  title: "Велосипед и Ролики",
  description: "Уникальный подход к развитию мозга через работу с органами чувств в специально оборудованной профессиональной среде.",
  icon: <Bike className="w-14 h-14 text-primary" strokeWidth={1.5} />
}, {
  title: "Поддержка родителей",
  description: "Психологическое сопровождение, консультации и сообщество единомышленников для гармонии в вашей семье.",
  icon: <HandHeart className="w-14 h-14 text-primary" strokeWidth={1.5} />
}, {
  title: "Предшкольная подготовка",
  description: "Адаптивные тренировки, превращающие физическое развитие в путь к личным победам, силе духа и уверенности в себе.",
  icon: <BookOpenCheck className="w-14 h-14 text-primary" strokeWidth={1.5} />
}];
export default function EducationalBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}